import React from 'react'
import { Icon } from '@shopflo/ui'
import { MinusCircle } from '@phosphor-icons/react'
import { CatalogueDataType } from 'src/lib/types/common/catalogue'
import CatalogueItemsList from './CatalogueItemsList'
import FormErrorText from 'src/components/common/FormErrorText'
import { useLocale } from 'src/lib/hooks/useLocal'
import { QuantityDistributionErrorType } from 'src/lib/utils/automationsHelpers'
import { getCatalogueGroupError } from 'src/lib/utils/catalogueErrorHelpers'
import { classNames } from 'src/lib/utils/helpers'

interface CatalogueItemsGroupProps {
  groupIndex: number
  displayGroup: CatalogueDataType[]
  actions: {
    onRemoveIncludedItem: (groupIndex: number, itemIndex: number) => void
    onRemoveExcludedItem?: (groupIndex: number, itemIndex: number) => void
    onUpdateItem?: (updatedItem: CatalogueDataType, groupIndex: number, itemIndex: number) => void
  }

  errorHandling: {
    errors?: QuantityDistributionErrorType[]
  }
  config?: {
    showVariantEditor?: boolean
  }
  renderItemPrefix?: (item: CatalogueDataType, itemIndex: number) => React.ReactNode
}

const CatalogueItemsGroup: React.FC<CatalogueItemsGroupProps> = ({
  groupIndex,
  displayGroup,
  actions,
  errorHandling,
  config = { showVariantEditor: true },
  renderItemPrefix
}) => {
  const { t } = useLocale()
  const group = displayGroup || []
  const includedItems = group.filter(item => item.type !== 'exclude')
  const excludedItems = group.filter(item => item.type === 'exclude')
  const { errors } = errorHandling

  const errorMessage = getCatalogueGroupError(errors ?? [], groupIndex)
  const hasChosenProducts = group.length > 0

  return (
    <div className={classNames('flex flex-col', hasChosenProducts ? 'mt-2' : 'mt-0')}>
      <CatalogueItemsList
        data={{ items: includedItems, groupIndex, displayGroup }}
        actions={{
          ...actions,
          onRemoveItem: actions.onRemoveIncludedItem
        }}
        errorHandling={errorHandling}
        config={config}
        renderItemPrefix={renderItemPrefix}
      />

      {excludedItems.length > 0 && (
        <>
          <div id={`exclusion-header-group-${groupIndex}`} className='flex gap-3 pl-2'>
            <div className='flex flex-col items-center'>
              <div className='h-2 w-[1px] bg-zinc-200' />
              <Icon IconComponent={MinusCircle} size='sm' className='text-zinc-400' />
              <div className='h-2 w-[1px] bg-zinc-200' />
            </div>
            <div className='flex flex-col justify-center pt-1'>
              <span className='text-text-xs-medium text-zinc-500'>{t('discounts_v2.excluding_items')}</span>
            </div>
          </div>
          <CatalogueItemsList
            data={{ items: excludedItems, groupIndex, displayGroup }}
            actions={{
              ...actions,
              onRemoveItem: actions.onRemoveExcludedItem!
            }}
            errorHandling={errorHandling}
            config={{ ...config, showVariantEditor: false }}
          />
        </>
      )}
      <FormErrorText message={errorMessage} />
    </div>
  )
}

export default CatalogueItemsGroup
